import { co2 } from './common';

export default {
  'consumption.co2': `Emissioni ${co2} ciclo misto`,
  'consumption.energy': 'Consumo di energia elettrica ciclo misto',
  'consumption.fuel': 'Consumo di carburante ciclo misto',
  'footnotes.local': '',
  'footnotes.wltp': `I valori di consumo carburante e autonomia sono stati rispettivamente rilevati: per il carburante, con le tecniche di misurazione della metodologia WLTP ai sensi del Regolamento di esecuzione (UE) 2017/1153 nella sua versione in vigore; per l’energia, ai sensi del Regolamento (UE) 683/2008. I valori dipendono dalla configurazione dell'auto.`,
  'footnotes.nedc': `I valori indicati sono stati rilevati in base al procedimento di misurazione prescritto. Si tratta dei "valori di ${co2} NEDC" ai sensi dell' art. 2 n. 1 del Regolamento di Esecuzione (UE) 2017/1153. I consumi di carburante sono stati calcolati sulla base di tali valori. I dati non si riferiscono ad un singolo veicolo e non sono parte integrante dell'offerta, ma sono forniti esclusivamente a titolo di confronto tra i diversi modelli. I valori variano a seconda degli equipaggiamenti a richiesta dei singoli veicoli.`,
  'footnotes.emissions.appendix': `Per maggiori informazioni sui dati ufficiali di consumo  carburante ed emissioni di ${co2} di veicoli nuovi si rimanda alla «Guida al risparmio di carburante, emissioni di C02 e consumo energetico», disponibile gratuitamente presso la rete di vendita MB e sul sito web del Ministero dello sviluppo economico.`,
  'search.input.label': 'La tua ricerca/ "OnlineCode Configurator"',
  'search.result.buy-online': 'Showroom Online',
  'search.results': 'Nessun risultato trovato. | {count} Risultato di ricerca | {count} Risultati di ricerca ',
  'search.results.count': '{count} Risultati di ricerca',
  'search.results.backup': 'Nessun risultato di ricerca. Vedi pagine correlate:',
  'search.results.none.summary':
    'Non è disponibile nessun risultato con questa chiave di ricerca. Per favore riprovare con un termine diverso.',
  'search.show-more': 'Mostra di più',
  'search.unavailable': 'La ricerca non è disponibile attualmente.',
  'search.result.new': 'Nuova',
  'input.placeholder': 'La tua ricerca/ "OnlineCode Configurator"',

  'search.result.consumption': 'Consumi',
  'watch.video': 'Guarda il video',
  'input.recently': 'Ricerche recenti',
  'input.help.title': 'Cosa dovresti cercare?',
  'input.help.text':
    'Effettua la ricerca utilizzando tipi di veicoli, modelli, codici di configurazione oppure accessori, altri prodotti e altre informazionion',

  all: 'Tutte',
  UCOS: 'Modelli usati',
  PASSENGER_CARS: 'Autovettura',
  VANS: 'Monovolume',
  NCOS: 'Scegli in pronta consegna',
  VIDEO: 'Video',
  DEALER_LOCATOR: 'Ricerca concessionaria',
  CONFIGURATOR: 'Configuratore',
  TEST_DRIVE: 'Test drive',
  VEHICLE_SEARCH: 'Ricerca vetture usate',
  COLLECT: 'Collezione & Accessori',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Accessori per auto',

  'search.result.grid': 'Griglia',
  'search.result.list': 'Elenco',

  // No results
  'support.check': 'Correggi eventuali errori di battitura oppure riprova con un termine diverso.',
  'support.no.results': 'La ricerca non ha prodotto risultati con questo termine.',
  'support.no.results.term': 'Nessun risultato trovato',
  'support.chat': 'Non trovi ciò che cerchi? Rivolgiti alla nostra assistenza ',
  'support.chat.with.us': 'online via chat',

  'search.results.offer': 'Offerte popolari per "{query}":',
};
